<template>
  <a-config-provider :locale="zh_CN">
    <router-view></router-view>
  </a-config-provider>
</template>

<script>
/* eslint-disable */
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN'
export default {
  name: 'app',
  data () {
    return {
      zh_CN
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
